<template>
  <div class="broken-image-container">
    <div class="broken-image-content">
      <ImageFileQuestion
        class="broken-image-icon"
        role="img"
        :aria-label="t('broken-image-icon')"
      />
      <FriedH3 class="broken-image-title">{{ t('Oops..') }}</FriedH3>
      <FriedParagraph class="broken-image-description">
        {{ t('could-not-load-image') }}
      </FriedParagraph>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import ImageFileQuestion from '../assets/image-file-question.svg';

const { t } = useI18n();
</script>

<style scoped>
.broken-image-container {
  background-color: var(--gray-99);
  width: 100%;
  height: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: var(--radius-medium);
}

.broken-image-title,
.broken-image-description {
  color: var(--text-gray);
}
</style>
